import { ref } from "vue";

type OrderBy = "title" | "first_name" | "last_name" | "email" | "text_feedback" | "rating_feedback" | "created_at";
type OrderDirection = "asc" | "desc";

const orderBy = ref<OrderBy>("created_at");
const orderDirection = ref<OrderDirection>("desc");

export const useSortFilters = () => ({
  orderBy,
  orderDirection,
  updateOrderBy: (v: OrderBy): void => {
    orderBy.value = v;
  },
  updateOrderDirection: (v: OrderDirection): void => {
    orderDirection.value = v;
  },
});
